const query = (id, isPreview) => `
{
    blockSlider(id: "${id}", preview: ${isPreview}) {
    title
    slidesToShowOnDesktop
    elementId
    description
    hasJobData
    jobsToShow
    countryFilter
    countryCode
    jobFamilyFilter
    variant
           cameoImages {
    internalTitle
    altText
    cameoMediumMobile {
      title
      description
      url
    }
    cameoMedium {
      title
      description
      url
    }
    cameoLargeMobile {
      title
      description
      url
    }
    cameoLarge {
      title
      description
      url
    }
  }
    contentSliceCollection(limit:10){
      items{
        ... on MultiColumnGridWithTextOrLink{
        __typename
        elementId
        heading
          textCardsCollection(limit:10){
            items{
              title
              description
              
              image{
                altText
                imageDesktop {
                  title
                  fileName
                  url
                  width
                  height
          			}
                imageMobile {
                  title
                  description
                  contentType
                  fileName
                  size
                  url
          			}
              }
              link{
                name
                url
          label
          title
          target
          scrollToElementId
          imageType
          gaEventClass
          gaEventLabel
          ariaLabel
          images{
            altText
            imageDesktop{
              url
             
            }
          }
              }
            }
            
          }
        }
      }
    }
    slidesCollection (limit:10) {
      items {
        ... on TextCards {
          __typename
          title
              elementid
              cardTag
              link{
                title
                url
                gaEventClass
                gaEventLabel
                ariaLabel
              }
              image{  
                altText
                imageDesktop{
                  url
                  width
                  height
                }
              }
          description
        }
          ... on MultiColumnGridWithTextOrLink{
          heading
    			elementId
    			variant
          __typename
          textCardsCollection (limit:5) {
        items {
          title
          description
          image {
            internalTitle
            altText
            imageDesktop {
              title
              fileName
              url
              width
              height
            }
            imageMobile {
              title
              description
              contentType
              fileName
              size
              url
            }
        }
        link {
          name
          url
          label
          title
          target
          scrollToElementId
          imageType
          gaEventClass
          gaEventLabel
          ariaLabel
          images{
            altText
            imageDesktop{
              url
             
            }
          }
        }
      }
    }
    
    
    
    multiRowTable{
      varient
      rowHeadingCollection{
        items{
          title
          shortDescription
        }
      }
      rowCardsCollection{
        items{
          column1{
            ...on ImageWithText{
              description
            }
          }
          column2{
            ...on ImageWithText{
              description
            }
          }
        }
      }
    }

    linksCollection (limit:5) {
      items {
        title
        description
        variant
        linksCollection {
          items {
            __typename ...on Link {
              label
              title
              scrollToElementId
              url
              target
              gaEventClass
              gaEventLabel
            }
          }
        }
      }
    }
        }
        ... on NewsStoryCard {
          __typename
          date
          isDateLink
          variant
          pdfLink{
            pdfName
            newLink
            title
            target
          }
          titleLink {
            name
            url
            label
            title
            target
            scrollToElementId
            imageType
            gaEventClass
            gaEventLabel
            ariaLabel
          }
          description
          categoryLinksCollection (limit : 50){
            items {
              name
              url
              label
              title
              target
              scrollToElementId
              imageType
              gaEventClass
              gaEventLabel
              ariaLabel
            }
          }
          image {
            altText
            imageMobile {
              title
              description
              contentType
              fileName
              size
              url
              width
              height
            }
            imageDesktop {
              title
              description
              contentType
              fileName
              size
              url
              width
              height
            }
          }
          video {
            internalTitle
            title
            youtubeVideoId
            posterImage {
              altText
              imageMobile {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
              imageDesktop {
                title
                description
                contentType
                fileName
                size
                url
                width
                height
              }
            }
            isModal
            enableWatchLater
            isImageToggle
          }
        }
      }
    }    
    link {
      name
      url
      label
      title
      target
      scrollToElementId
      imageType
      gaEventClass
      gaEventLabel
      ariaLabel 
      images {
        internalTitle
        altText
        imageDesktop {
          title
          description
          contentType
          fileName
          size
          url
          width
          height
        }
        imageMobile {
          title
          description
          contentType
          fileName
          size
          url
          width
          height
        }
      }
      
    }
    textContent{
           title
    longTitle
    shortDescription
    content
    variant
    cameoImages {
    internalTitle
    altText
    cameoMediumMobile {
      title
      description
      url
    }
    cameoMedium {
      title
      description
      url
    }
  }
    badgeHeading
    badgeContent
    jsonEditor
    elementId
    socailIconEnable
    socialLinks {
      internalTitle
      linkCollection{
        items{
          title
          url
          ariaLabel
          images{
            altText
            imageMobile {
              title
              description
              contentType
              fileName
              size
              url
              width
              height
            }
            imageDesktop {
              title
              description
              contentType
              fileName
              size
              url
              width
              height
            }

          }
        }
      }
    }  
  }  
    variant
    sliderSettings {
      slidesToShowMobile
      slidesToScrollMobile
      slidesToShowTab
      slidesToScrollTab
    }
  }
}
`

module.exports = { query }